import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { Checkbox, CheckboxGroup } from '~c/components/base/checkbox';

interface Props {
  className?: string;
}

const RadioGroupDemo: React.FC<Props> = ({ className }) => {
  const [check1, setCheck1] = React.useState(false);
  const [check2, setCheck2] = React.useState(false);

  return (
    <CheckboxGroup
      className={className}
      title="CheckboxGroup"
      helperText="helper text"
    >
      <Checkbox
        label="Check 1"
        checked={check1}
        onChange={(evt, checked) => setCheck1(checked)}
      />
      <Checkbox
        label="Check 2"
        checked={check2}
        onChange={(evt, checked) => setCheck2(checked)}
      />
    </CheckboxGroup>
  );
};

export default muiStyled(RadioGroupDemo)(({ theme }) => css``);
